import axios from 'axios';

class ViaCepApiClass {
  getAddress({term = null, onSuccess = null, onError = null}) {
    const url = `/application/get_address?term=${term}`;
    axios.get(url).then(onSuccess).catch(onError);
  }
}

export const ViaCepApi = new ViaCepApiClass();